"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marginNotificationsMiddleware = void 0;
var _snackbarActions = require("../../actions/snackbarActions");
var _marginNotificationsReducer = require("../reducers/marginNotificationsReducer");
var marginNotificationsMiddleware = exports.marginNotificationsMiddleware = function marginNotificationsMiddleware(store) {
  return function (next) {
    return function (action) {
      var result = next(action);
      if (action.type === _snackbarActions.ADD_SNACK) {
        var _state$user;
        var state = store.getState();
        var notifications = state.margin.notifications;
        var userId = (_state$user = state.user) === null || _state$user === void 0 || (_state$user = _state$user.userInfo) === null || _state$user === void 0 ? void 0 : _state$user.UserId;
        if (userId) {
          (0, _marginNotificationsReducer.setUserMarginNotifications)(userId, notifications);
        }
      }
      return result;
    };
  };
};